/**
 * Ksting
 *
 * Copyright © 2017 Chris Andersson <chris@wbisbi.com>. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

import React, { Component } from 'react';
import { shape, string, array, func, bool, object } from 'prop-types';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import md5 from 'md5';

import p from 'polyglot/polyglot';

import { createUrl } from 'utils/urlHelper';

import {
  UPDATE_PASSWORD_SUCCESS,
  updatePassword as updatePasswordAction,
} from 'actions/user';

import StepHeader from 'components/StepHeader/StepHeader';
import Form from 'components/Form/Form';

import styles from './update-password.scss';

/**
 * This is the UpdatePassword component.
 *
 * @author Chris Andersson <chris@wbisbi.com>
 */
export class UpdatePassword extends Component {
  /**
   * Declare expected prop types.
   *
   * @type {object}
   */
  static propTypes = {
    match: shape({
      path: string.isRequired,
      params: shape({
        resetCode: string.isRequired,
      }).isRequired,
    }).isRequired,
    updatePasswordForm: shape({
      fieldsets: array.isRequired,
      validationMessages: object.isRequired,
      submitText: string.isRequired,
      sending: bool.isRequired,
      errors: object.isRequired,
    }).isRequired,
    history: object.isRequired,
    updatePassword: func.isRequired,
  };

  onSubmit = data => {
    const { updatePassword, history, match: { params } } = this.props;
    const { resetCode } = params;
    const { password } = data;

    updatePassword({
      reset_code: resetCode,
      password_hash: md5(password),
    }).then(({ type }) => {
      if (type === UPDATE_PASSWORD_SUCCESS) {
        // Go to login.
        history.push(createUrl('login'));
      }
    });
  };

  /**
   * Render UpdatePassword.
   *
   * @return {Object}
   */
  render() {
    const { updatePasswordForm } = this.props;

    return (
      <main className={styles.wrapper}>
        <div className={styles.container}>
          <div className={styles.row}>
            <div className={styles.content}>
              <StepHeader
                title={p.t('new_password.title')}
                current={2}
                total={2}
              />

              <Form {...updatePasswordForm} onSubmit={this.onSubmit} />
            </div>
          </div>
        </div>
      </main>
    );
  }
}

export default withRouter(
  connect(({ updatePasswordForm }) => ({ updatePasswordForm }), {
    updatePassword: updatePasswordAction,
  })(UpdatePassword)
);
